export default __webpack_public_path__ + "static/media/4_paynopain.1db64a1e.svg";